<template>
<div>

    <el-crud :baseUrl="'/employees/'+id+'/shifts'" 
        v-model="resource"
        :actions="[]"
        :config="crudConfig"
        :filters="filters"
        ref="crud">

        <template slot="crudFiltersDescription">
            <div>Fecha: <strong>{{filters.date_from}}</strong> a <strong>{{filters.date_to}}</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-form-item label="Fechas" prop="date_range" required :rules="[{required: true, message: 'Campo requerido'}]">
                <el-date-picker
                    v-model="filters.date_range"
                    type="daterange"
                    @change="dateRangePickerChange"
                    format="yyyy-MM-dd"
                    align="right"
                    placeholder="Seleccione una fecha">
                </el-date-picker>                
            </el-form-item>
        </template>

        <template slot="table">
            <el-table-column
                prop="description"
                label="Turno">
            </el-table-column>
            <el-table-column
                label="Fecha Desde">
                <template slot-scope="scope">
                    {{scope.row.pivot.date_from}}
                </template>
            </el-table-column>
            <el-table-column
                label="Fecha Hasta">
                <template slot-scope="scope">
                    {{scope.row.pivot.date_to}}
                </template>
            </el-table-column>
        </template>
<!-- 
        <template slot="form" slot-scope="scope">
            <el-form-item label="Turno" label-width="100px" :error="scope.errors.shift">
                <el-select v-model="resource.shift_id" filterable placeholder="Seleccione" size="mini">
                    <el-option
                        v-for="item in shiftsOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Fechas" label-width="100px">
                <el-date-picker
                    v-model="resource.date_from"
                    type="date"
                    placeholder="Desde" size="mini">
                </el-date-picker>
                <el-date-picker
                    v-model="resource.date_to"
                    type="date"
                    placeholder="Hasta" size="mini">
                </el-date-picker>
            </el-form-item>
        </template>
 -->    
    </el-crud>

</div>
</template>

<script>
    import el_crud from '../el-crud.vue';
    export default {
        name: 'employee-shifts',
        props: {
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                employee_id: null,
                crudConfig:{
                    // level: 'L2',
                    // AddItemTitle: 'Asignar turno',
                    // DeleteItemConfirmMessage: 'Esto borrará permanentemente la asignación al turno. Desea continuar?'
                },
                resource:{
                //     shift_id: null,
                //     date_from: null,
                //     date_to: null,
                },
                // shiftsOptions: [],
                filters: {
                    // functional_area_id: null,
                    // filter: null,
                    date_range: null,
                    date_from: null,
                    date_to: null,
                },
            };
        },
        components: {
            'el-crud': el_crud,
        },
        // mounted() {
        //     axios.get('/api/shifts/options').then((response) => {
        //         _.each(response.data, (description, id) => {
        //             this.shiftsOptions.push({label: description, value: id})
        //         });
        //         this.shiftsOptions = _.sortBy(this.shiftsOptions, 'label');
        //     });
        // }
        methods: {
            dateRangePickerChange () {
                let value = this.filters.date_range;
                // console.log(value);
                this.filters.date_from = moment(value[0]).format('YYYY-MM-DD');
                this.filters.date_to = moment(value[1]).format('YYYY-MM-DD');
            },
        }
    }
</script>
